<template>
  <div class="container" @keyup.esc="$parent.cerrarModal" tabindex="-1" ref="modalito">
    <div class="loading" v-if="loading">
      <div class="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span>{{$i18n.t('modal.loading')}}</span>
    </div>
    <button
      class="w3-display-topright btn btn-danger"
      style="margin-top:15px;z-index:99"
      v-on:click="$parent.cerrarModal"
    >
      <i class="fa fa-times"></i>
    </button>
    <div
      class="shadow-lg p-3 mb-5 bg-white rounded row"
      style="margin-top:10px;height:100%;overflow:auto"
    >
      <div class="col-sm" style="max-width:550px;">
        
        <form ref="fileform" class="fileform">
          <span class="drop-files">{{$i18n.t("modal.drag-and-drop")}}</span>
        </form>
        
        <input type="file" class="stylosFile" @change="agregarArchivo" multiple ref="archivos" />

        <div style="margin-top: 5px; border: 1px solid black;">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="unionEtiquetas" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">
              Utilizar mismas etiquetas para videos e imagenes
            </label>
          </div>
          <div class="alert alert-primary d-flex align-items-center" role="alert">
            <div><i class="fas fa-info-circle" style="font-size:1.5em"></i> {{alertMsj}}</div>
          </div>
        </div>

        <vue-tags-input
          v-model="tagImg"
          :autocomplete-items="filteredItemsImg"
          :add-on-key="[13,' ', ',']"
          :autocomplete-min-length="3"
          @before-adding-tag="checkTagImg"
          @tags-changed="cambiosImg"
          :placeholder="$i18n.t('modal.addTagImg')"
          style="margin-top: 10px;"
        />

        <hr>
        
        <div class="form-inline" style="margin:3px;">
          <select class="form-control" v-model="type">
            <option value="youtube">Youtube</option>
            <option value="facebook">Facebook</option>
            <option value="twitter">Twitter</option>
            <option value="vimeo">Vimeo</option>
            <option value="Otros">Otros</option>
          </select>
          <div class="form-group" style="margin-left:2%">
            <label for="links">Links:</label>
          </div>
          <div class="form-group">
            <input type="text" v-model="link" class="form-control" />
          </div>
          <button class="btn btn-danger" @click="agregarLink">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        
        <vue-tags-input
          v-model="tagVideo"
          :autocomplete-items="filteredItemsVideo"
          :add-on-key="[13,' ', ',']"
          :autocomplete-min-length="3"
          @before-adding-tag="checkTagVideo"
          @tags-changed="cambiosVideo"
          :placeholder="$i18n.t('modal.addTagVideo')"
          style="margin-top: 15px;"
        />
        
        <button
          class="btn btn-success"
          v-on:click.prevent="subirArchivo"
          v-show="recursos.length > 0"
          style="margin-top: 15px;"
        >{{$i18n.t('modal.submit')}}</button>
        
        <h5 style="margin-top: 15px;">Visualización de imagenes/videos</h5>
        
        <div style="max-height:200px; overflow-y:auto">
          <div v-for="(file, key) in recursos" class="file-listing" v-bind:key="key">
            <div v-if="file.tipo == 'archivo'">
              <img
                :src="url(file)"
                style="max-width:45px;max-height:45px;overflow-wrap: break-word;"
              />
              {{ file.name }}
              <i
                style="font-size:25px;color:red;cursor:pointer;float:right"
                @click="recursos.splice(key, 1)"
                class="fa fa-times"
              ></i>
            </div>
            <div v-else>
              <a :href="file.name" target="_blank">
                <img
                  :src="`https://img.youtube.com/vi/${obtenerV(file.name)}/default.jpg`"
                  style="max-width:45px;max-height:45px;overflow-wrap: break-word;"
                  v-if="file.name.includes('youtube')"
                />
                {{file.name.slice(2)}}
              </a>
              <i
                style="font-size:25px;color:red;cursor:pointer;float:right"
                @click="recursos.splice(key, 1)"
                class="fa fa-times"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <h1 class="h1">{{$i18n.t('modal.listArt')}}</h1>
        <div class="table-responsive-sm" style="max-height:300px;max-width:500px;overflow:auto;">
          <table class="table table-bordered table-condensed">
            <tbody>
              <tr v-for="(articulo,index) in articulos" v-bind:key="index">
                <th scope="row">{{articulo.codigo}}</th>
                <td>{{articulo.descripcion}}</td>
                <td v-if="articulo.marca">{{(articulo.marca)?articulo.marca.nombre:''}}</td>
                <td v-if="articulo.modelo">{{(articulo.modelo)?articulo.modelo : ''}}</td>
                <td v-if="articulo.medida">{{(articulo.medida)?articulo.medida : ''}}</td>
                <td>
                  <i
                    style="font-size:25px;color:red;cursor:pointer;float:right"
                    @click="articulos.splice(index, 1)"
                    class="fa fa-times"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notify from "devextreme/ui/notify";
import { alert } from "devextreme/ui/dialog";
import VueTagsInput from "@johmun/vue-tags-input";
// import ws from "../config.json";
// import { DxProgressBar } from "devextreme-vue/progress-bar";
export default {
  name: "modal",
  props: {
    articulosId: Array
  },
  components: {
    VueTagsInput,
    // DxProgressBar
  },
  data() {
    return {
      dragAndDropCapable: false,
      unionEtiquetas: false,
      showAlert: true,
      alertMsj: "Esta opción unifica las etiquetas seleccionadas de las imagenes y video para crear los recursos y los links con las mismas etiqueta para ambos",
      loading: false,
      maxValue: 10,
      seconds: this.maxValue,
      logError: [],
      articulos: [],
      recursos: [],
      type: "youtube",
      link: "",
      tagImg: "",
      tagVideo: "",
      /*eslint no-useless-escape: "error"*/
      re: new RegExp(/^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/, "g"),
      request: {
        crossDomain: true,
        headers: {
          EmpID: sessionStorage.getItem("empId"),
          Authorization:
            "Basic " +
            btoa(
              sessionStorage.getItem("usuario") +
                ":" +
                sessionStorage.getItem("clave")
            )
        }
      },
      labelsImg: [],
      labelsVideo: [],
      etiquetas: []
    };
  },
  created() {
    this.axios
      .get(this.$store.getters.ws.api_recursos + "/labels", {
        params: {
          size: 1000
        }
      })
      .then(json => {
        this.etiquetas = json.data.content.map(p => p.nombre);
      });
    this.articulos = this.articulosId;
  },
  computed: {
    /* FILTRA EN LAS ETIQUETAS DEPENDIENDO LOS TAGS Q SE HAYAN COLOCADO EN LOS LABELS DE LAS IMAGENES */
    filteredItemsImg() {
      let filtro = this.etiquetas.filter(i => {
        return i.toLowerCase().indexOf(this.tagImg.toLowerCase()) !== -1;
      });
      let arrayObj = []
      if (filtro && filtro.length > 0) {
        for (let nombre of filtro) {
          arrayObj.push({ text: nombre })
        }
      }
      return arrayObj;
    },
    /* FILTRA EN LAS ETIQUETAS DEPENDIENDO LOS TAGS Q SE HAYAN COLOCADO EN LOS LABELS DE LOS VIDEOS */
    filteredItemsVideo() {
      let filtro = this.etiquetas.filter(i => {
        return i.toLowerCase().indexOf(this.tagVideo.toLowerCase()) !== -1;
      });
      let arrayObj = []
      if (filtro && filtro.length > 0) {
        for (let nombre of filtro) {
          arrayObj.push({ text: nombre })
        }
      }
      return arrayObj;
    }
  },
  methods: {
    agregarArchivo() {
      for (let i = 0; i < this.$refs.archivos.files.length; i++) {
        if (
          this.$refs.archivos.files[i].size <=
          this.$store.getters.ws.max_file_size_mb
        ) {
          let aux = this.$refs.archivos.files[i];
          aux.tipo = "archivo";
          this.recursos.push(aux);
        } else
          alert(
            `No se pueden subir archivos con mas de ${this.$store.getters.ws
              .max_file_size_mb / 1000000}MB`
          );
      }
    },
    obtenerV(link) {
      if (link.indexOf("&") == -1 && link.indexOf("=") == -1) {
        let result = link.slice(2);
        return result.slice(result.indexOf("/") + 1);
      } else if (link.indexOf("&") == -1) {
        return link.slice(link.indexOf("=") + 1);
      } else {
        return link.slice(link.indexOf("=") + 1, link.indexOf("&"));
      }
    },
    agregarLink() {
      this.link = this.link.replace(/ /g, "");
      if (this.re.test(this.link)) {
        if (this.link.includes("https:")) {
          this.link = this.link.replace("https:", "");
        } else {
          this.link = this.link.replace("http:", "");
        }
        this.recursos.push({
          name: this.link,
          tipo: "link",
          type: this.type
        });
        this.link = "";
        /*eslint no-useless-escape: "error"*/
      } else if (/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/.test(this.link)) {
        this.link = `//${this.link}`;
        this.recursos.push({
          name: this.link,
          tipo: "link",
          type: this.type
        });
        this.link = "";
      } else {
        notify(this.$i18n.t("modal.errorUrl"), "warning", 5000);
      }
    },
    cambios(arrayLabels) {
      let aux = "";
      arrayLabels.forEach(elem => {
        if (elem == arrayLabels[0]) {
          aux += elem;
        } else {
          aux += "," + elem;
        }
      });
      return aux;
    },
    /* LABELS O ETIQUETA FINALES QUE VAN A QUEDAR PARA LAS IMAGENES */
    cambiosImg(array) {
      this.labelsImg = array.map(p => p.text);
      this.labelsImg = this.cambios(this.labelsImg);
    },
    /* LABELS O ETIQUETA FINALES QUE VAN A QUEDAR PARA LOS VIDEOS */
    cambiosVideo(array) {
      this.labelsVideo = array.map(p => p.text);
      this.labelsVideo = this.cambios(this.labelsVideo);
    },
    checkTagImg(obj) {
      if (
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toUpperCase()) ||
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toLowerCase())
      ) {
        if (obj.tag.text.length > 3) {
          obj.addTag();
        }
      } else {
        if (obj.tag.text.length > 3) {
          let r = confirm("Quiere agregar la etiqueta nueva " + obj.tag.text + " ?");
          if (r) {
            this.axios.post(this.$store.getters.ws.api_recursos + "/labels", { nombre: obj.tag.text })
              .then(() => {
                notify("Se agrego la etiqueta " + obj.tag.text, "success", 2000);
              });
            obj.addTag();
          }
        }
      }
    },
    checkTagVideo(obj) {
      if (
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toUpperCase()) ||
        this.etiquetas.map(x => x.toLowerCase()).includes(obj.tag.text.toLowerCase())
      ) {
        if (obj.tag.text.length > 3) {
          obj.addTag();
        }
      } else {
        if (obj.tag.text.length > 3) {
          let r = confirm("Quiere agregar la etiqueta nueva " + obj.tag.text + " ?");
          if (r) {
            this.axios.post(this.$store.getters.ws.api_recursos + "/labels", { nombre: obj.tag.text })
              .then(() => {
                notify("Se agrego la etiqueta " + obj.tag.text, "success", 2000);
              });
            obj.addTag();
          }
        }
      }
    },
    
    determineDragAndDropCapable() {
      /*
    Create a test element to see if certain events
    are present that let us do drag and drop.
  */
      var div = document.createElement("div");

      /*
    Check to see if the `draggable` event is in the element
    or the `ondragstart` and `ondrop` events are in the element. If
    they are, then we have what we need for dragging and dropping files.

    We also check to see if the window has `FormData` and `FileReader` objects
    present so we can do our AJAX uploading
  */
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    removeFile(key) {
      this.recursos.splice(key, 1);
    },
    async subirArchivo() {
      console.log("ENTRO A SUBIR EL ARCHIVO -------------------");

      this.loading = true;
      var _id;
      let files = this.recursos.filter(p => p.tipo == "archivo");
      let links = this.recursos.filter(p => p.tipo == "link");

      if (this.unionEtiquetas == true || this.unionEtiquetas == "true") {
        
        if (files.length > 0 && links.length > 0) {

          let aux = [];

          /* BUSCO LAS ETIQUETAS CARGADAS PARA LAS IMAGENES */
          if (this.labelsImg && this.labelsImg.length > 0) {
            
            let arrayImg = this.labelsImg.split(",");

            arrayImg.forEach(e => { 
              aux.push(e); 
            });
          
          }

          /* BUSCO LAS ETIQUETAS CARGADAS PARA LOS VIDEOS */
          if (this.labelsVideo && this.labelsVideo.length > 0) {
            
            let arrayVideo = this.labelsVideo.split(",");
            
            arrayVideo.forEach(e => { 
              aux.push(e); 
            });
          
          }

          let etiq = "";
          
          if (aux.length > 0) {
            /* QUITO LAS ETIQUETAS REPETIDAS */
            aux = [...new Set(aux)];

            /* SETEO LOS DATOS */
            etiq = aux.join(",");
            
          }

          this.labelsImg = etiq;
          this.labelsVideo = etiq;

        }

      }

      if (files > 0) {
        for (let p of files) {
          delete p.tipo;
          return p;
        }
      }
      
      if (links.length > 0) {
        for (let p of links) {
          delete p.tipo;
          if (this.labelsVideo.length > 0) {
            p.labels = this.labelsVideo;
          } else {
            p.labels = "";
          }
        }
      }
      
      for (var j = 0; j < this.articulos.length; j++) {

        if (typeof this.articulos[j].bucket_id == "undefined" || this.articulos[j].bucket_id == null) {

          _id = await this.bucketExist(this.articulos[j].id);

          if (_id == "false" || _id == false) {
            
            /* ARTICULO SIN BUCKET_ID EN SU PROPIEDAD DE ARTICULO Y SIN BUCKET TAMPOCO EN RECURSOS */
            _id = await this.crearBucket(this.articulos[j].id, links);

            if (files.length > 0) {
              for (let i = 0; i < files.length; i++) {
                await this.realizarSuba(_id, files[i], this.labelsImg);
              }
            }

          } else {

            /* ARTICULO SIN BUCKET_ID EN SU PROPIEDAD DE ARTICULO PERO CON BUCKET EXISTENTE EN RECURSOS !! */
            await this.actualizarLinks(_id, links);

            for (let i = 0; i < files.length; i++) {
              this.agregarBucketId(_id, this.articulos[j].id);
              await this.realizarSuba(_id, files[i], this.labelsImg);
            }

          }

        } else {

          await this.actualizarLinks(this.articulos[j].bucket_id, links);

          if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
              await this.realizarSuba(this.articulos[j].bucket_id, files[i], this.labelsImg);
            }
          }

        }
      }
      this.loading = false;
      notify("Se ha realizado la carga de los archivos", "success", 5000);
      this.$parent.cerrarModal();
    },
    async bucketExist(id) {
      let _id = false;

      await this.axios
        .get(this.$store.getters.ws.api_recursos + "/buckets/?nombre=art_" + id)
        .then(r => {
          if (r.data.content.length) {
            _id = r.data.content[0]._id;
          }
        })
        .catch();

      return _id;
    },
    async realizarSuba(_id, file, labels) {
      try {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("bucket_id", _id);
        formData.append("labels", labels);
        formData.append("descripcion", "Algo");
        let _idRecurso;
        await this.axios
          .post(this.$store.getters.ws.api_recursos + "/resources", formData)
          .then(p => {
            _idRecurso = p.data._id;
          });
        await this.vincular(_id, _idRecurso);
      } catch (err) {
        if (err.response) {
          this.logError.push({
            archivo: file.name,
            error: err.response.data.exception
          });
        }
      }
    },
    async crearBucket(id, links) {
      let _id = false;
      try {
        await this.axios
          .post(this.$store.getters.ws.api_recursos + "/buckets", {
            nombre: "art_" + id,
            nota: "Nota para el articulo n" + id,
            links: links
          })
          .then(r => {
            _id = r.data._id;
          });
      } catch (err) {
        alert(err);
      }
      if (_id != false) {
        await this.agregarBucketId(_id, id);
      }
      return _id;
    },
    async actualizarLinks(_id, links) {
      try {
        await this.axios
          .put(this.$store.getters.ws.api_recursos + "/buckets/" + _id, {
            links: links
          })
          .then(() => {});
      } catch (e) {
        alert("No se pudo vincular los links con el recurso");
      }
    },
    async vincular(_id, _idRecurso) {
      try {
        await this.axios
          .post(this.$store.getters.ws.api_recursos + "/buckets/" + _id + "/link/" + _idRecurso, {})
          .then(() => {});
      } catch (err) {
        alert("No se pudo vincular");
      }
    },
    async agregarBucketId(_id, artId) {
      try {
        this.axios({
          method: "put",
          url: this.$store.getters.ws.api_paljet + "/articulos/" + artId,
          headers: this.request.headers,
          crossDomain: this.request.crossDomain,
          data: {
            bucket_id: _id
          }
        }).then(notify("Se agrego el buckets al articulo"));
      } catch (err) {
        notify("No se pudo vincular. " + err);
      }
    },
    url(file) {
      if (file.type.includes("image")) {
        return URL.createObjectURL(file);
      } else if (file.name.toLowerCase().includes(".xls")) {
        return require("../img/xls.png");
      } else if (file.name.toLowerCase().includes(".pdf")) {
        return require("../img/pdf2.png");
      } else {
        return require("../img/noPreview.png");
      }
    }
  },
  mounted() {
    /*
    Determine if drag and drop functionality is capable in the browser
  */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
    If drag and drop capable, then we continue to bind events to our elements.
  */
    if (this.dragAndDropCapable) {
      /*
      Listen to all of the drag events and bind an event listener to each
      for the fileform.
    */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
          this.$refs.fileform.addEventListener(
            evt,
            function(e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      /*
      Add an event listener for drop to the form
    */
      this.$refs.fileform.addEventListener(
        "drop",
        function(e) {
          /*
        Capture the files from the drop event and add them to our local files
        array.
      */
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            if (
              e.dataTransfer.files[i].size <=
              this.$store.getters.ws.max_file_size_mb
            ) {
              let aux = e.dataTransfer.files[i];
              aux.tipo = "archivo";
              this.recursos.push(aux);
            } else
              alert(
                "No se pueden subir archivos con mas de " +
                  this.$store.getters.ws.max_file_size_mb / 100000 +
                  "MB."
              );
          }
        }.bind(this)
      );
    }
  }
};
</script>
<style>

.stylosFile {
  padding-top:5px;
  display:block;
  border:none;
  width:100%
}

.table-condensed {
  font-size: 13px;
}
.fileform {
  display: block;
  height: 200px;
  margin: auto;
  margin-top: 10px;
  border-radius: 4px;
  border: 4px dashed gray;
}
.container .fileform {
  max-width: 500px;
  text-align: center;
  line-height: 200px;
}
div .file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
div .remove-container {
  text-align: center;
}

div .remove-container a {
  color: red;
  cursor: pointer;
}
#file-drag-drop {
  background: white;
  border: 1px solid black;
  border-radius: 10px;
  padding: 1%;
  height: 600px;
  overflow-y: scroll;
  -webkit-box-shadow: 7px 10px 24px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 7px 10px 24px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 7px 10px 24px 0px rgba(0, 0, 0, 0.75);
}
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
@media (max-width: 991.98px) {
  .container .fileform {
    display: none;
  }
}
.loading {
  position: absolute;
  top: 25%;
  left: 50%;
  background: rgb(255, 255, 255);
  z-index: 3;
}
.lds-grid {
  display: block;
  width: 64px;
  height: 64px;
  border: 1px solid;
  border-radius: 10px;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgb(0, 0, 0);
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}
@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.complete .dx-progressbar-range {
  background-color: green;
}
#progress-bar-status {
  display: inline-block;
  margin: 20px;
}
</style>